import React from "react";
import CloseIcon from "@dcl/icons/esm/ui/cross";
import SearchIcon from "@dcl/icons/esm/ui/search";
import { getClassNameFactory } from "@dcl/ui";
export var CountryFilter = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var closeLabel = _ref.closeLabel,
      inputId = _ref.inputId,
      setValue = _ref.setValue,
      nothingFoundWarning = _ref.nothingFoundWarning,
      onClose = _ref.onClose,
      placeholder = _ref.placeholder,
      value = _ref.value;
  var getClassName = getClassNameFactory(CountryFilter.displayName);

  var handleChange = function handleChange(event) {
    setValue(event.target.value);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "wrapper"
    }),
    ref: ref,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "closeButtonWrapper"
    })
  }, /*#__PURE__*/React.createElement("button", {
    className: getClassName({
      descendantName: "closeButton"
    }),
    onClick: onClose,
    "aria-label": closeLabel
  }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inputWrapper"
    })
  }, /*#__PURE__*/React.createElement("label", {
    className: getClassName({
      descendantName: "label"
    }),
    htmlFor: inputId
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "inputIcon"
    }),
    role: "presentation"
  }, /*#__PURE__*/React.createElement(SearchIcon, null)), /*#__PURE__*/React.createElement("span", {
    className: "u-hiddenVisually"
  }, placeholder)), /*#__PURE__*/React.createElement("input", {
    className: getClassName({
      descendantName: "input"
    }),
    id: inputId,
    onChange: handleChange,
    placeholder: placeholder,
    type: "text",
    value: value
  })), nothingFoundWarning && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "nothingFoundWarning"
    })
  }, nothingFoundWarning));
});
CountryFilter.displayName = "CountryFilter";